// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import FaceIdentifyLayout from "../../components/facesearch/FaceIdentifyLayout";
import {
  getFaceFromEnrolment,
  setCurrentFace,
  enrolMultiple
} from "../../actions/faceActions";

import { updatePerson } from "../../actions/peopleActions";
import type {
  EnrolmentInputModel,
  PersonInputModel
} from "../../types/InputModels";

class FaceIdentify extends Component<*> {
  enrolMultiple = (
    personId: string,
    enrolment: EnrolmentInputModel,
    doneBack?: Function,
    failBack?: Function
  ) => {
    let person: PersonInputModel = {
      uuid: personId,
      newEnrolments: [enrolment]
    };

    this.props.actions.updatePerson(person, doneBack, failBack);
  };
  render(): * {
    return (
      <FaceIdentifyLayout
        setImageError={this.props.setImageError}
        faceSearch={this.props.faceSearch}
        isV1Model={
          this.props.defaultFacebase && this.props.defaultFacebase.model === 4
        }
        setCurrentFace={this.props.actions.setCurrentFace}
        getFaceFromEnrolment={this.props.actions.getFaceFromEnrolment}
        enrolMultiple={this.enrolMultiple}
      />
    );
  }
}

const mapStateToProps = (state: stateProps): * => ({
  faceSearch: state.v3account.faceSearch,
  defaultFacebase: state.v3account.user.defaultFacebase
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { getFaceFromEnrolment, setCurrentFace, enrolMultiple, updatePerson },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FaceIdentify);
